const theme = {
  grey:{
    "primary": '#2c95d3',  // 主颜色
    "menuBar": "#3d3a39", // 一级菜单背景色
    "menuTextColor":"#FFFFFF", // 一级菜单字体颜色
    "menuHover":"#797979", // 一级菜单移上去颜色
    "subMenuBar":"#3d3a39",  // 二级菜单背景色
    "subMenuHover": "#797979", // 二级菜单鼠标移上去颜色显示
    "subMenuTextColor": "" // 暂时没看到使用的地方 
  },
  blue:{
    "primary": '#2c95d3',  
    "menuBar": "#2c95d3",
    "menuTextColor":"#FFFFFF", 
    "menuHover":"#1f7ecc",
    "subMenuBar":"#2c95d3", 
    "subMenuHover": "#1f7ecc", 
    "subMenuTextColor": ""
  },
  green: {
    "primary": '#41d62b', 
    "menuBar": "#41d62b",
    "menuTextColor":"#FFFFFF", 
    "menuHover":"#16B200",
    "subMenuBar":"#41d62b",
    "subMenuHover": "#16B200", 
    "subMenuTextColor": ""
  },
  orange: {
    "primary": '#FF9124',
    "menuBar": "#FF9124",
    "menuTextColor":"#FFFFFF",
    "menuHover":"#DD7918", 
    "subMenuBar":"#FF9124", 
    "subMenuHover": "#DD7918", 
    "subMenuTextColor": "" 
  }
}
export { 
  theme
}